import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { Lock } from 'lucide-react';
export function LoginPage() {
  const {
    login
  } = useAuth();
  const [email, setEmail] = useState('admin.maker@cdns.gov.pk');
  const [password, setPassword] = useState('password');
  const [step, setStep] = useState<'credentials' | 'otp'>('credentials');
  const [otp, setOtp] = useState(['', '', '', '', '', '']);
  const [isLoading, setIsLoading] = useState(false);
  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    // Simulate API call
    setTimeout(() => {
      setIsLoading(false);
      setStep('otp');
    }, 1000);
  };
  const handleOtpChange = (index: number, value: string) => {
    if (value.length > 1) return;
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    // Auto-focus next input
    if (value && index < 5) {
      const nextInput = document.getElementById(`otp-${index + 1}`);
      nextInput?.focus();
    }
  };
  const handleVerifyOtp = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    // Simulate verification
    setTimeout(() => {
      login(email);
      setIsLoading(false);
    }, 1500);
  };
  return <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#1B6B3A] to-[#145A2E] p-4" data-id="element-278">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-md overflow-hidden" data-id="element-279">
        {/* Header */}
        <div className="p-8 text-center border-b border-gray-100" data-id="element-280">
          <img src="https://cdn.magicpatterns.com/uploads/tWYmSpJz5EKRVmEj9X8aaH/CDNS.jpg" alt="CDNS - National Savings Logo" className="w-24 h-24 mx-auto mb-4 object-contain" data-id="element-281" />
          <h1 className="text-2xl font-bold text-[#1B6B3A] tracking-wide" data-id="element-282">
            Branch Payment Portal
          </h1>
          <div className="h-1 w-16 bg-[#D4A017] mx-auto my-3 rounded-full" data-id="element-283"></div>
          <p className="text-gray-600 font-medium" data-id="element-284">
            Central Directorate of National Savings
          </p>
          <p className="text-sm text-gray-500 mt-1" data-id="element-285">
            Vendor Digital Payment Portal
          </p>
        </div>

        {/* Form */}
        <div className="p-8" data-id="element-286">
          {step === 'credentials' ? <form onSubmit={handleLogin} className="space-y-6" data-id="element-287">
              <Input label="Email Address" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="user@cdns.gov.pk" required data-id="element-288" />
              <Input label="Password" type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" required data-id="element-289" />
              <Button type="submit" className="w-full" size="lg" isLoading={isLoading} data-id="element-290">
                Login to Portal
              </Button>
            </form> : <form onSubmit={handleVerifyOtp} className="space-y-6" data-id="element-291">
              <div className="text-center mb-6" data-id="element-292">
                <h3 className="text-lg font-medium text-gray-900" data-id="element-293">
                  Two-Factor Authentication
                </h3>
                <p className="text-sm text-gray-500 mt-1" data-id="element-294">
                  Enter the 6-digit code sent to your mobile
                </p>
              </div>

              <div className="flex justify-between gap-2" data-id="element-295">
                {otp.map((digit, idx) => <input key={idx} id={`otp-${idx}`} type="password" inputMode="numeric" pattern="[0-9]*" autoComplete="one-time-code" maxLength={1} value={digit} onChange={e => {
              const val = e.target.value.replace(/\D/g, '');
              handleOtpChange(idx, val);
            }} onKeyDown={e => {
              if (e.key === 'Backspace' && !digit && idx > 0) {
                const prevInput = document.getElementById(`otp-${idx - 1}`);
                prevInput?.focus();
              }
            }} className="w-12 h-12 text-center text-xl font-bold border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#1B6B3A] focus:border-[#1B6B3A] outline-none transition-colors" data-id="element-296" />)}
              </div>

              <div className="bg-blue-50 p-3 rounded-md flex items-start" data-id="element-297">
                <Lock className="w-5 h-5 text-blue-600 mt-0.5 mr-2 flex-shrink-0" data-id="element-298" />
                <p className="text-xs text-blue-700" data-id="element-299">
                  Your session will expire automatically after 15 minutes of
                  inactivity for security.
                </p>
              </div>

              <Button type="submit" className="w-full" size="lg" isLoading={isLoading} data-id="element-300">
                Verify & Login
              </Button>

              <button type="button" onClick={() => setStep('credentials')} className="w-full text-sm text-gray-500 hover:text-[#1B6B3A]" data-id="element-301">
                Back to Login
              </button>
            </form>}
        </div>

        {/* Footer */}
        <div className="bg-gray-50 px-8 py-4 text-center border-t border-gray-100" data-id="element-302">
          <p className="text-xs text-gray-500" data-id="element-303">
            Secure Payment Portal • v 1.0.0
          </p>
        </div>
      </div>
    </div>;
}